module.exports = __webpack_public_path__ + "static/media/ng.9eea84ef.svg";